module.exports = __webpack_public_path__ + "img/12.47d6431b.jpg";